import { Injectable } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SearchComboItemModel } from '../models/search-combo-item-model';
import { ConstantsService } from './constants.service';

@Injectable({
  providedIn: 'root'
})
export class FormsService {

  constructor(private fb: FormBuilder, private constants: ConstantsService) { }

  initSearchForm(): FormGroup {
    return this.fb.group({
      keywords: new FormControl(''),
      indexId: new FormControl(this.constants.indexEHD),
      openProceedings: new FormControl(true),
      closedProceedings: new FormControl(true),
      [this.constants.property_operator_any]: this.fb.array([]),
      [this.constants.property_operator_all]: this.fb.array([])
    });
  }

  newProp(): FormGroup {
    return this.fb.group({
      propertyItem: '',
      keywords: '',
      startDate: '',
      endDate: '',
      dateOperator: 'between',
      textOperator: this.constants.text_operator_contains,
      isDate: false
    });
  }

  props(searchForm: FormGroup, operator: string): FormArray {

    if (operator === this.constants.property_operator_any) {
      return searchForm.get(this.constants.property_operator_any) as FormArray;
    }

    return searchForm.get(this.constants.property_operator_all) as FormArray;
  }

  updateProp(prop: SearchComboItemModel): FormGroup {
    return this.fb.group({
      propertyItem: prop.propertyItem,
      keywords: prop.keywords,
      startDate: prop.startDate,
      endDate: prop.endDate,
      dateOperator: prop.dateOperator,
      textOperator: prop.textOperator,
      isDate: false
    });
  }

  updateDateProp(prop: SearchComboItemModel): FormGroup {
    return this.fb.group({
      propertyItem: prop.propertyItem,
      keywords: prop.keywords,
      startDate: prop.startDate,
      endDate: prop.endDate,
      dateOperator: prop.dateOperator,
      textOperator: prop.textOperator,
      isDate: true
    });
  }

  pushProp(searchForm: FormGroup, item: FormGroup, operator: string) {
    this.props(searchForm, operator).push(item)
  }

  addProp(searchForm: FormGroup, operator: string) {
    this.props(searchForm, operator).push(this.newProp());
  }

  removeProp(searchForm: FormGroup, index: number, operator: string) {
    this.props(searchForm, operator).removeAt(index);
  }

  clearProp(searchForm: FormGroup, index: number, operator: string) {
    this.props(searchForm, operator).removeAt(index);

    this.props(searchForm, operator).insert(index, this.newProp());
  }
}
